<template>
  <div class="pc-data-edit">
    <h2>城市创新指数</h2>
    <div class="detail-data">
      <div class="innovative-list clearfix">
        <div
          v-for="item in innovativedata"
          :key="item.id"
          class="innovative-item"
        >
          <p>{{ item.name }}</p>

          <el-input
            v-if="editCity"
            v-model="item.value"
            placeholder="信息值"
          ></el-input>
          <p v-else>{{ item.value ? item.value : "无数据值" }}</p>
          <el-input
            v-if="editCity"
            v-model="item.year"
            @change="show"
            placeholder="信息时间"
          ></el-input>
          <p v-else>{{ item.year ? item.year : "无时间" }}</p>
        </div>
      </div>
    </div>
    <div class="result">
      <p class="title">结果值</p>
      <div class='content'>
        <p class='value'>105</p>
        <p class="iconfont icon-suo1"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      innovativedata: [
        {
          name: "Density of leisure facilities",
          value: "",
          type: "innovativeIndex",
          year: "",
        },
        { name: "R&D/GDP", type: "innovativeIndex", value: "", year: "" },
        { name: "FDI/GDP", type: "innovativeIndex", value: "", year: "" },
        {
          name: "GDP per capita",
          type: "innovativeIndex",
          value: "",
          year: "",
        },
        { name: "Undergraduat", type: "innovativeIndex", value: "", year: "" },
        {
          name: "Entrepreneurial youth",
          type: "innovativeIndex",
          value: "",
          year: "",
        },
      ],
    };
  },
  props: { dataDetail: Array, editCity: Boolean },
  watch: {
    dataDetail(val, newval) {
      if (val) {
        val.forEach((item) => {
          this.innovativedata.forEach((item2, index) => {
            if (item.name == item2.name) {
              this.$set(this.innovativedata, index, item);
            }
          });
        });
      }
    },
  },
  methods: {
    getInnovativeData() {
      let data = this.innovativedata;
      return data;
    },
    show() {
      console.log(this.innovativedata);
    },
  },
};
</script>

<style scoped lang="scss">
.pc-data-edit {
  box-shadow: $boxshadow;
  padding: 35px 30px 20px;
  margin-top: 40px;
  > h2 {
    border-bottom: 1px solid $border-color;
    font-size: 20px;
    padding-bottom: 15px;
    color: $mainTitle;
    margin-bottom: 20px;
  }
  .detail-data {
    .innovative-list {
      width: 100%;
      padding-bottom: 20px;
      border-bottom: 1px solid $border-color;
      .innovative-item {
        float: left;
        width: 25%;
        p {
          line-height: 40px;
          height: 40px;
          font-size: 16px;
          font-weight: bold;
        }
        /deep/ .el-input {
          width: 80%;
          margin-bottom: 10px;
        }
      }
    }
  }
  .result{
      .title{
          margin-top:20px;
          font-size: 16px;
          font-weight:bold;
          margin-bottom:10px;
      }
      .content{
          display:flex;
         .value{
              font-size: 34px;
              color:$lightenYellow;
              line-height:40px;
              font-weight:bold;
           
          }
          .iconfont{
            margin-left:10px;
              line-height:40px;
              font-size: 20px;
              color:$secondTitle;
          }
      }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/map/cityDetail/cityInnovativeIndex.vue